var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 469.333 469.333",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m170.667 336.6 64 64 64-64c-35.307-35.307-92.694-35.307-128 0zM85.333 251.267 128 293.933c58.88-58.88 154.453-58.88 213.333 0L384 251.267c-82.453-82.454-216.213-82.454-298.667 0z",
    fill: "#18a457",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 165.933 42.667 208.6c106.027-106.027 277.973-106.027 384 0l42.667-42.667C339.733 36.333 129.6 36.333 0 165.933z",
    fill: "#18a457",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenWifi);
export default __webpack_public_path__ + "static/media/green_wifi.f53ba03ae8597a6fcc5095966f587b1a.svg";
export { ForwardRef as ReactComponent };